import { render, staticRenderFns } from "./ZoneGrid.vue?vue&type=template&id=24c020b6&"
import script from "./ZoneGrid.vue?vue&type=script&lang=js&"
export * from "./ZoneGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports